import { render, staticRenderFns } from "./ButtonUpdate.vue?vue&type=template&id=0decdcbf&scoped=true&"
import script from "./ButtonUpdate.vue?vue&type=script&lang=js&"
export * from "./ButtonUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonUpdate.vue?vue&type=style&index=0&id=0decdcbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0decdcbf",
  null
  
)

export default component.exports